import React from 'react';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { Box, Flex } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

const StyledLoader = styled.div`
  margin-top: ${token('space.250')};
`;

export const CreateBillingProfileModalLoader = () => {
  return (
    <Box paddingBlockStart="space.150" paddingBlockEnd="space.150">
      <StyledLoader>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="40%" />
        </SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          <Flex direction="column" gap="space.0">
            <SkeletonLoader width="70%" />
            <SkeletonLoader width="90%" />
          </Flex>
        </SkeletonLoaderWrapper>
        <br />
        <SkeletonLoaderWrapper>
          <Flex direction="column">
            <SkeletonLoader width="70%" />
            <SkeletonLoader width="90%" />
          </Flex>
        </SkeletonLoaderWrapper>
        <br />
        <SkeletonLoaderWrapper>
          <Flex direction="column">
            <SkeletonLoader width="70%" />
            <SkeletonLoader width="90%" />
          </Flex>
        </SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="30%" isRightAligned />
        </SkeletonLoaderWrapper>
      </StyledLoader>
    </Box>
  );
};
